"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = exports.RateLimitError = exports.BadRequestError = exports.NotFoundError = exports.QueuedError = void 0;
class RequestError extends Error {
    constructor(message, statusCode, type, body) {
        super(message);
        this.statusCode = statusCode || 500;
        this.type = type || null;
        this.body = body || null;
    }
}
class QueuedError extends RequestError {
    constructor(body) {
        super("Lookup queued", 202, "async_created", body);
    }
}
exports.QueuedError = QueuedError;
class NotFoundError extends RequestError {
    constructor(body) {
        super("Record not found", 404, "not_found", body);
    }
}
exports.NotFoundError = NotFoundError;
class BadRequestError extends RequestError {
    constructor(body) {
        super("Bad request", 400, "bad_request", body);
    }
}
exports.BadRequestError = BadRequestError;
class RateLimitError extends RequestError {
    constructor(body) {
        super("Too many requests", 429, "rate_limit", body);
    }
}
exports.RateLimitError = RateLimitError;
class UnknownError extends RequestError {
    constructor(body) {
        super("API error", 500, "api_error", body);
    }
}
exports.UnknownError = UnknownError;
//# sourceMappingURL=errors.js.map